module.exports = "/assets/ca9ec51c6f86c6ac4b05c7ea0f4330ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/QV.png
// module id = 1765
// module chunks = 0